// Purely for testing redux

import store from './store/index-store.js'

window.store = store
